import { DialogActions } from '@mui/material';
import React from 'react';
import { Button } from '../Button';

interface Props {
  onClose?: () => void;
  onSubmit?: () => void | Promise<void>;
  closeText?: string;
  submitText?: string;
  disabled?: boolean;
}

export const ModalFooter: React.FC<Props> = ({ onClose, onSubmit, closeText, submitText, disabled }) => {
  return (
    <DialogActions
      sx={{
        backgroundColor: '#FCFCFC',
        padding: '0.5rem 1.5rem',
        display: 'flex',
        justifyContent: !onClose ? 'flex-end' : 'space-between',
        gap: '1.5rem',
        alignItems: 'center',
        borderTop: '0.0625rem solid #CAC4D0',
      }}
    >
      {onClose && (
        <Button disabled={disabled} type="secondary" onClick={onClose}>
          {closeText || 'Cancel'}
        </Button>
      )}
      {onSubmit && (
        <Button disabled={disabled} type="primary" onClick={onSubmit} sx={!onClose ? { width: 'fit-content' } : {}}>
          {submitText || 'Save'}
        </Button>
      )}
    </DialogActions>
  );
};
